// extracted by mini-css-extract-plugin
export default {"root":"xuX_OLUHgk","root_placeholder":"s53UzgLODX","root_dragging":"RUxLQgDN0W","root_hidden":"yeLNTZqvc_","root_editMode":"cnmeMrCmjw","root_editable":"SEhv9eqH2c"};